import React from 'react';
import { IntakeFormData, SERVICES } from '../../types/form';

interface Props {
  data: IntakeFormData;
  onChange: (updates: Partial<IntakeFormData>) => void;
}

const inputClass = `
  w-full bg-dark-700 border border-dark-500 rounded-lg px-4 py-3
  text-white text-sm placeholder-gray-600
  focus:outline-none focus:border-lime-400 focus:ring-1 focus:ring-lime-400/20
  transition-all duration-200
`;

const labelClass = "block text-xs font-medium text-gray-300 uppercase tracking-wider mb-2";

const Step2Services: React.FC<Props> = ({ data, onChange }) => {
  const toggleService = (service: string) => {
    const current = data.services;
    if (current.includes(service)) {
      onChange({ services: current.filter(s => s !== service) });
    } else {
      onChange({ services: [...current, service] });
    }
  };

  return (
    <div className="space-y-5 animate-fade-up">
      <div>
        <h2 className="font-display text-2xl font-semibold text-white mb-1">
          What are you looking for?
        </h2>
        <p className="text-sm text-gray-300">Select everything that applies — we handle it all under one roof.</p>
      </div>

      <div>
        <label className={labelClass}>Services Needed *</label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {SERVICES.map(service => {
            const selected = data.services.includes(service);
            return (
              <button
                key={service}
                type="button"
                onClick={() => toggleService(service)}
                className={`
                  text-left px-4 py-3 rounded-lg border text-sm font-medium
                  transition-all duration-200 flex items-center gap-3
                  ${selected
                    ? 'border-lime-400 bg-lime-400/10 text-lime-400'
                    : 'border-dark-500 bg-dark-700 text-gray-400 hover:border-dark-400 hover:text-gray-300'
                  }
                `}
              >
                <span className={`
                  w-4 h-4 rounded flex-shrink-0 border flex items-center justify-center
                  transition-all duration-200
                  ${selected ? 'bg-lime-400 border-lime-400' : 'border-dark-400'}
                `}>
                  {selected && (
                    <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6l3 3 5-5" stroke="#0a0a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </span>
                {service}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <label className={labelClass}>Project Description *</label>
        <textarea
          className={`${inputClass} resize-none`}
          rows={4}
          placeholder="Describe what you're looking to accomplish. The more detail, the better we can prepare..."
          value={data.projectDescription}
          onChange={e => onChange({ projectDescription: e.target.value })}
        />
      </div>

      <div>
        <label className={labelClass}>What does success look like?</label>
        <textarea
          className={`${inputClass} resize-none`}
          rows={3}
          placeholder="More leads, more sales, better brand recognition, rank on Google..."
          value={data.goals}
          onChange={e => onChange({ goals: e.target.value })}
        />
      </div>
    </div>
  );
};

export default Step2Services;
